import React from 'react';
import Image from 'next/image';

interface SectionImageProps {
    imageUrl?: string;
    imageTitle?: string;
    className?: string;
    isLCP?: boolean; // New prop to mark the LCP (Largest Contentful Paint) image
}

const SectionImage = ({ imageUrl, imageTitle, className, isLCP = false }: SectionImageProps) => {
    return (
        <div className={`flex w-full items-center justify-center gap-3 ${className}`}>
            <Image
                src={imageUrl || ' '}
                alt={imageTitle || 'headerImage'}
                loading='eager' // Eager loading for critical images
                width={1000}
                height={1000}
                quality={100}
                priority={isLCP} // Apply priority only for the LCP image
                className={'w-full h-auto lg:max-w-xl select-none object-contain'}
            />
        </div>
    );
};

export default SectionImage;
